<script lang="ts">
  import {  FormGroup, Input} from "sveltestrap";
  import { BasicRadioButtons, CheckedRadio, CheckedRadioMessage, DefaultRadio, DefaultRadioMessage,FlatSkinCheck,FlatSkinCheckMessage, InlineCheckbox, InlineCheckboxMessage } from "../../../../utils/Constant/Constant";
  let radioGroup: any;
</script>
<tr>
    <td>{BasicRadioButtons}</td>
    <td class="w-50">
      <FormGroup>
        <Input id="radio" type="radio" label="Default radio" />
      </FormGroup>
    </td>
    <td><span>{BasicRadioButtons}</span></td>
</tr>
<tr>
    <td>{DefaultRadio}</td>
    <td>
      <FormGroup>
        <Input id="radio" type="radio" label="Option 1" class="radio-primary" />
      </FormGroup>
    </td>
    <td><span>{@html DefaultRadioMessage}</span></td>
</tr>
<tr>
    <td>{CheckedRadio}</td>
    <td>
      <FormGroup>
        <Input id="radio" type="radio" label="Checked" checked />
      </FormGroup>
    </td>
    <td><span>{@html CheckedRadioMessage}</span></td>
</tr>
<tr>
    <td>{FlatSkinCheck}</td>
    <td>
      <FormGroup>
        <Input id="radio" type="radio" label="Disabled" disabled />
      </FormGroup>
    </td>
    <td><span>{@html FlatSkinCheckMessage}</span></td>
</tr>
<tr>
    <td>{InlineCheckbox}</td>
    <td>
      <FormGroup class="m-b-0 m-checkbox-inline">
        <Input id="r1" type="radio" bind:group={radioGroup} value="eenie" label="Option 1" />
        <Input id="r2" type="radio" bind:group={radioGroup} value="meanie" label="Option 1"/>
        <Input id="r3" type="radio" bind:group={radioGroup} value="minie" label="Option 1"/>
      </FormGroup>
    </td>
    <td><span>{@html InlineCheckboxMessage}</span></td>
</tr>